import { render } from "./TriviaContentQuiz.vue?vue&type=template&id=1124a79a"
import script from "./TriviaContentQuiz.vue?vue&type=script&lang=js"
export * from "./TriviaContentQuiz.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__